/**
 *
 * HubspotVerify
 *
 */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { makeSelectIsVerify, makeSelectError } from './selectors';
import { verifyHubspot } from './actions';
import reducer from './reducer';
import saga from './saga';
import queryString from 'query-string';
import {
  VerifyContainer,
  VerifyContent,
  VerifyHeaderWrapper,
  VerifyDivider,
  VerifyLogo,
} from './styled';
import logo from 'assets/img/brand/logo-full.png';
import routeTemplates from 'common/route-templates';
import { NOTIFICATION } from 'common/constants';
import triggerNotification from 'utils/triggerNotification';

export const HubspotVerify = props => {
  useInjectReducer({ key: 'hubspotVerify', reducer });
  useInjectSaga({ key: 'hubspotVerify', saga });
  const { verifyHubspotStart, isVerify, error, history } = props;
  console.log('redirect url', window.location.href);

  const verifyCode = queryString.parse(props.location.search).code;
  let state, integrationKey;

  try {
    state = JSON.parse(decodeURIComponent(queryString.parse(props.location.search).state));
    integrationKey = state && state.integrationKey;
  } catch (e) {
    triggerNotification({
      title: 'Something went wrong. Please try again',
      type: NOTIFICATION.TYPE.ERROR,
    });
  }

  useEffect(() => {
    if (verifyCode && state) {
      verifyHubspotStart({
        payload: { code: verifyCode, state: JSON.stringify(state), integrationKey },
        metadata: { projectName: state },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyCode]);

  return (
    <>
      <Helmet>
        <title>ZoomInfo Chat | Verify Hubspot</title>
        <meta name="description" content="Verify your Hubspot" />
      </Helmet>
      <VerifyContainer>
        <div className="d-flex justify-content-center p-5">
          <VerifyLogo src={logo} alt="zoominfo chat logo" />
        </div>
        <VerifyContent>
          {isVerify ? (
            <>
              <VerifyHeaderWrapper>Pending</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Verification Pending</p>
            </>
          ) : error ? (
            <>
              <VerifyHeaderWrapper>Failed</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Something went wrong while connecting Hubspot with ZoomInfo Chat</p>
            </>
          ) : (
            <>
              <VerifyHeaderWrapper>Successful</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Successfully connected your Hubspot with ZoomInfo Chat</p>
            </>
          )}
        </VerifyContent>
      </VerifyContainer>
    </>
  );
};
HubspotVerify.propTypes = {
  verifyHubspotStart: PropTypes.func.isRequired,
  isVerify: PropTypes.bool,
};
export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    isVerify: makeSelectIsVerify(),
    error: makeSelectError(),
  });
};
export const mapDispatchToProps = dispatch => {
  return {
    verifyHubspotStart: ({ payload, metadata }) =>
      dispatch(verifyHubspot.start({ payload, metadata })),
  };
};
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withRouter, withConnect)(HubspotVerify);
